module.exports = __webpack_public_path__ + "img/beecoin-3.59672cbd.svg";